import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHypertrackerHip3MenuIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15 7.97582C15 12.6043 12.1675 14.0894 10.6751 12.767C9.44671 11.6887 9.08122 9.41014 7.2335 9.17617C4.88832 8.88117 4.68528 12.0041 3.14214 12.0041C1.34518 12.0041 1 9.38979 1 8.04702C1 6.67374 1.38579 4.80201 2.91878 4.80201C4.70559 4.80201 4.80711 7.47737 7.04061 7.33495C9.26396 7.18237 9.30457 4.3951 10.7462 3.20493C12.0051 2.1775 15 3.2863 15 7.97582Z",
		fill: "#1A1B23"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15 7.97582C15 12.6043 12.1675 14.0894 10.6751 12.767C9.44671 11.6887 9.08122 9.41014 7.2335 9.17617C4.88832 8.88117 4.68528 12.0041 3.14214 12.0041C1.34518 12.0041 1 9.38979 1 8.04702C1 6.67374 1.38579 4.80201 2.91878 4.80201C4.70559 4.80201 4.80711 7.47737 7.04061 7.33495C9.26396 7.18237 9.30457 4.3951 10.7462 3.20493C12.0051 2.1775 15 3.2863 15 7.97582Z",
		fill: "white",
		fillOpacity: .5
	})]
});
export default SvgHypertrackerHip3MenuIcon;
